
// Import vendor modules.
import Alpine from "@alpinejs/csp";

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

Alpine.directive( "scroll-to", ScrollToDirective );

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

function ScrollToDirective( element, metadata, framework ) {

	var target = metadata.expression
		? document.querySelector( metadata.expression )
		: element
	;

	if ( target ) {

		target.scrollIntoView();

	}

}
